import { cache } from 'react';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { APP_CONFIG_DEFAULTS } from '@/app-config';
import type { AppConfig } from '@/app-config';

export const CONFIG_ENDPOINT = process.env.NEXT_PUBLIC_APP_CONFIG_ENDPOINT;
export const SANDBOX_ID = process.env.SANDBOX_ID;

export const THEME_STORAGE_KEY = 'theme-mode';
export const THEME_MEDIA_QUERY = '(prefers-color-scheme: dark)';

export interface SandboxConfig {
  [key: string]:
    | { type: 'string'; value: string }
    | { type: 'number'; value: number }
    | { type: 'boolean'; value: boolean }
    | null;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function msToSeconds(ms: unknown): number | null {
  const n = typeof ms === "number" ? ms : Number(ms);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round((n / 1000) * 1000) / 1000;
}

export const formatPreciseTime = (secs: number): string => {
  const total = secs || 0;

  const minutes = Math.floor(total / 60);
  const seconds = Math.floor(total % 60);
  const hundredths = Math.floor((total - Math.floor(total)) * 100);

  return `${minutes} min ${String(seconds).padStart(2, '0')}.${String(hundredths).padStart(2, '0')} sec`;
};
export function safeParseJson(value: any): any | null {
  if (!value || typeof value !== "string") return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}


// https://react.dev/reference/react/cache#caveats
// > React will invalidate the cache for all memoized functions for each server request.
export const getAppConfig = cache(async (headers: Headers): Promise<AppConfig> => {
  if (CONFIG_ENDPOINT) {
    const sandboxId = SANDBOX_ID ?? headers.get('x-sandbox-id') ?? '';

    // try {
    //   if (!sandboxId) {
    //     throw new Error('Sandbox ID is required');
    //   }

    //   const response = await fetch(CONFIG_ENDPOINT, {
    //     cache: 'no-store',
    //     headers: { 'X-Sandbox-ID': sandboxId },
    //   });

    //   if (response.ok) {
    //     const remoteConfig: SandboxConfig = await response.json();

    //     const config: AppConfig = { ...APP_CONFIG_DEFAULTS, sandboxId };

    //     for (const [key, entry] of Object.entries(remoteConfig)) {
    //       if (entry === null) continue;
    //       // Only include app config entries that are declared in defaults and, if set,
    //       // share the same primitive type as the default value.
    //       if (
    //         (key in APP_CONFIG_DEFAULTS &&
    //           APP_CONFIG_DEFAULTS[key as keyof AppConfig] === undefined) ||
    //         (typeof config[key as keyof AppConfig] === entry.type &&
    //           typeof config[key as keyof AppConfig] === typeof entry.value)
    //       ) {
    //         // @ts-expect-error I'm not sure quite how to appease TypeScript, but we've thoroughly checked types above
    //         config[key as keyof AppConfig] = entry.value as AppConfig[keyof AppConfig];
    //       }
    //     }

    //     return config;
    //   } else {
    //     console.error(
    //       `ERROR: querying config endpoint failed with status ${response.status}: ${response.statusText}`
    //     );
    //   }
    // } catch (error) {
    //   console.error('ERROR: getAppConfig() - lib/utils.ts', error);
    // }
  }

  return APP_CONFIG_DEFAULTS;
});

// check provided accent colors against defaults
// apply styles if they differ (or in development mode)
// generate a hover color for the accent color by mixing it with 20% black
export function getStyles(appConfig: AppConfig) {
  const { accent, accentDark } = appConfig;

  return [
    accent
      ? `:root { --primary: ${accent}; --primary-hover: color-mix(in srgb, ${accent} 80%, #000); }`
      : '',
    accentDark
      ? `.dark { --primary: ${accentDark}; --primary-hover: color-mix(in srgb, ${accentDark} 80%, #000); }`
      : '',
  ]
    .filter(Boolean)
    .join('\n');
}
